import type { VoidFunctionComponent } from 'react';

import SavedFiltersDropdownActionsContainer from './SavedFiltersDropdownActionsContainer';
import SavedFiltersDropdownListContainer from './SavedFiltersDropdownListContainer';

import styles from '../generic/SavedResources/SavedResource.module.less';

/**
 * SavedFilters refers to the two UI components which
 * power the saved filters feature. They are placed above the
 * issue filters on the IssuesInbox page.
 */
const SavedFilters: VoidFunctionComponent = () => (
  <div className={styles.savedResourceDropdowns}>
    <div className={styles.savedResourceDropdownsList}>
      <SavedFiltersDropdownListContainer />
    </div>
    <div className={styles.savedResourceDropdownsActions}>
      <SavedFiltersDropdownActionsContainer />
    </div>
  </div>
);

export default SavedFilters;
